import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09eefd39"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ant-btn-group ss-grupo-recursos" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Novo", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  class: "ss-card ss-card-space ss-alinhar-texto-esquerda",
  style: {"min-height":"55%"}
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 1,
  class: "acoes-item"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = {
  key: 5,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Produto :", -1))
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Tipo Produção :", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Data Criação:", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Data Inicio :", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Data Conclusão :", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Status :", -1))
const _hoisted_22 = { class: "acoes-item ss-alinhar-centro" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_busca_geral = _resolveComponent("busca-geral")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_paginacao = _resolveComponent("paginacao")!
  const _component_card = _resolveComponent("card")!
  const _component_ordem_producao_modal = _resolveComponent("ordem-producao-modal")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_titulo_padrao, {
          identificadorRecurso: _ctx.telaBase.identificadorRecurso,
          tituloRecurso: _ctx.telaBase.titulo,
          exibirAtalhosTela: true,
          exibirHistoricoTela: true,
          empresasSelecionadas: [_ctx.state.empresaSelecionada]
        }, {
          BotoesAcoes: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                class: "ant-btn ant-btn-secondary ss-btn-recursos",
                title: "Imprimir",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.PDF)))
              }, [
                _createVNode(_component_icone, { nome: "imprimir" })
              ]),
              _createElementVNode("button", {
                class: "ant-btn ant-btn-secondary ss-btn-recursos",
                title: "Exportar Word",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.Word)))
              }, [
                _createVNode(_component_icone, { nome: "word" })
              ]),
              _createElementVNode("button", {
                class: "ant-btn ant-btn-secondary ss-btn-recursos",
                title: "Exportar Excel",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.Excel)))
              }, [
                _createVNode(_component_icone, { nome: "excel" })
              ]),
              _createElementVNode("button", {
                class: "ant-btn ant-btn-secondary ss-btn-recursos",
                title: "Exportar CSV",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.CSV)))
              }, [
                _createVNode(_component_icone, { nome: "download-arquivo" })
              ]),
              (_ctx.telaBase.permissaoDados.incluir)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "ant-btn ant-btn-primary ss-btn-tela",
                    style: {"width":"100%"},
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.incluir()))
                  }, _hoisted_6))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["identificadorRecurso", "tituloRecurso", "empresasSelecionadas"]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_busca_geral, {
            empresas: [_ctx.state.empresaSelecionada],
            ordenacao: _ctx.telaBase.ordenacaoSelecionada,
            "onUpdate:ordenacao": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.telaBase.ordenacaoSelecionada) = $event)),
            buscaRapida: _ctx.state.buscaRapida,
            "onUpdate:buscaRapida": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.buscaRapida) = $event)),
            buscaAvancada: _ctx.state.buscaAvancada,
            "onUpdate:buscaAvancada": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.buscaAvancada) = $event)),
            onBuscarDados: _ctx.buscarOrdemProducao,
            placeholder: 'Busca rápida: Digite o número de identificação, data, valor ou alguma informação da pessoa para localizarmos o que você procura...'
          }, null, 8, ["empresas", "ordenacao", "buscaRapida", "buscaAvancada", "onBuscarDados", "placeholder"]),
          _createVNode(_component_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_table, {
                columns: _ctx.gradeBase.layoutMobile? _ctx.gradeBase.colunasMobile.filter(item => item.visible) :  _ctx.gradeBase.colunas.filter(item => item.visible),
                "data-source": _ctx.state.ordemProducao,
                rowKey: "codigo",
                pagination: false,
                loading: _ctx.telaBase.carregando,
                scroll: _ctx.gradeBase.layoutMobile?null: { x: (_ctx.gradeBase.windowWidth +500), y: _ctx.window.innerHeight - 300 },
                "row-selection": { selectedRowKeys: _ctx.gradeBase.codigosSelecionados },
                size: "small"
              }, {
                bodyCell: _withCtx(({ column, record, text }) => [
                  (column.customRenderRow === _ctx.ECustomRenderRow.LinkAcao)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.editar(record.codigo))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(text), 1)
                      ], 8, _hoisted_8))
                    : (column.customRenderRow === _ctx.ECustomRenderRow.IconeAcoes)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("a", {
                            class: "visualizar",
                            onClick: ($event: any) => (_ctx.editar(record.codigo))
                          }, [
                            _createVNode(_component_icone, { nome: "visualizar" })
                          ], 8, _hoisted_10),
                          (_ctx.obterStatus(record.status)==='pendente')
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                onClick: ($event: any) => (_ctx.confirmarExclusao(record)),
                                class: "excluir"
                              }, [
                                _createVNode(_component_icone, { nome: "excluir" })
                              ], 8, _hoisted_11))
                            : _createCommentVNode("", true)
                        ]))
                      : (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                        : (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text)), 1))
                          : (column.key === 'Status')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                _createVNode(_component_a_tag, {
                                  title: text,
                                  class: _normalizeClass('ss-tag-status op-' + _ctx.obterStatus(record.status))
                                }, null, 8, ["title", "class"]),
                                _createTextVNode(_toDisplayString(text), 1)
                              ], 64))
                            : (column.key === 'Codigo')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  _createElementVNode("span", null, [
                                    _hoisted_15,
                                    _createTextVNode(),
                                    _createElementVNode("a", {
                                      onClick: ($event: any) => (_ctx.editar(record.codigo))
                                    }, _toDisplayString(record.descricao), 9, _hoisted_16)
                                  ]),
                                  _createElementVNode("span", null, [
                                    _hoisted_17,
                                    _createTextVNode(" " + _toDisplayString(record.tipoProducao), 1)
                                  ]),
                                  _createElementVNode("span", null, [
                                    _hoisted_18,
                                    _createTextVNode(" " + _toDisplayString(record.dataCriacao), 1)
                                  ]),
                                  _createElementVNode("span", null, [
                                    _hoisted_19,
                                    _createTextVNode(" " + _toDisplayString(record.dataInicio), 1)
                                  ]),
                                  _createElementVNode("span", null, [
                                    _hoisted_20,
                                    _createTextVNode(" " + _toDisplayString(record.dataConclusao), 1)
                                  ]),
                                  _createElementVNode("span", null, [
                                    _hoisted_21,
                                    _createTextVNode(" " + _toDisplayString(record.descricaoSelecionado), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("a", {
                                      class: "visualizar",
                                      onClick: ($event: any) => (_ctx.editar(record.codigo))
                                    }, [
                                      _createVNode(_component_icone, { nome: "visualizar" })
                                    ], 8, _hoisted_23),
                                    (_ctx.obterStatus(record.status)==='pendente')
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          onClick: ($event: any) => (_ctx.confirmarExclusao(record)),
                                          class: "excluir"
                                        }, [
                                          _createVNode(_component_icone, { nome: "excluir" })
                                        ], 8, _hoisted_24))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                  _createTextVNode(_toDisplayString(text), 1)
                                ], 64))
                ]),
                emptyText: _withCtx(() => [
                  _createVNode(_component_mensagem_sem_dados, {
                    resultadoPesquisa: !_ctx.telaBase.carregando,
                    mensagem: _ctx.telaBase.carregando?'Buscando informações, por favor aguarde...':'Nenhum registro foi encontrado com estes filtros!'
                  }, null, 8, ["resultadoPesquisa", "mensagem"])
                ]),
                _: 1
              }, 8, ["columns", "data-source", "loading", "scroll", "row-selection"]),
              _createVNode(_component_paginacao, {
                gradeBase: _ctx.gradeBase,
                "onUpdate:gradeBase": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.gradeBase) = $event)),
                mostrarPaginacao: true,
                mostrarTotalRegistros: false,
                onBuscarDados: _ctx.buscarOrdemProducao
              }, null, 8, ["gradeBase", "onBuscarDados"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_ordem_producao_modal, {
      operacao: _ctx.state.operacaoLancamento,
      visivel: _ctx.state.exibirModal,
      "onUpdate:visivel": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.exibirModal) = $event)),
      onConfirmacao: _cache[10] || (_cache[10] = ($event: any) => (_ctx.atualizarInformacoesTela()))
    }, null, 8, ["operacao", "visivel"]),
    _createVNode(_component_preview_pdf, {
      arquivos: _ctx.state.arquivosPdf
    }, null, 8, ["arquivos"])
  ]))
}